import React, { useEffect, useState } from 'react'
import { useChangeServiceProductStatusMutation, useDeleteServiceProductMutation, useServiceProductsQuery, useServicesQuery } from '../../../Store/Apis/servicesApi'
import Error from '../../../Components/Error/Error'
import Loader from '../../../Components/Loader/Loader'
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import AddEditServiceProduct from '../../../Components/AddEditServiceProduct/AddEditServiceProduct';
import { Modal } from 'react-bootstrap';
import { isDropdownPermission } from '../../../Hooks/permissionsMiddleware';
import { useSelector } from 'react-redux';
import { useOutletsQuery } from '../../../Store/Apis/outletApi';

const Products = () => {
  const user = useSelector((state) => state.auth.user)
  const [sortFilter, setSortFilter] = useState({
    search: '',
    filter: '',
    outletID: ''
  });
  const outletList = useOutletsQuery()
  const serviceList = useServicesQuery()
  const serviceProductsApi = useServiceProductsQuery({
    keyname: sortFilter.search,
    keyID: sortFilter.filter,
    outletID: sortFilter.outletID
  })
  const [viewEditItem, setViewEditItem] = useState(null);
  

  // STAUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeServiceProductStatus] = useChangeServiceProductStatusMutation()
  const handleChangeStatus = () => {
    changeServiceProductStatus(selectedStatus).then((res)=>{
      console.log(res)
      setSelectedStatus(null)
    })
  }

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteServiceProduct] = useDeleteServiceProductMutation()
  const handleDelete = () => {
    deleteServiceProduct(selectedRecord).then((res)=>{
      console.log(res)
      setSelectedRecord(null)
    })
  }


  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID
      });
    }
  }, []);

  const columns = [
    {
      title: 'Product/Service Name',
      dataIndex: 'productServiceName',
      key: 'productServiceName',
      sorter: (a, b) => a.productServiceName.localeCompare(b.serviceName),
      filter: (value, record) => record.productServiceName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.productServiceName.toLowerCase().includes(value.toLowerCase()),
      render: (i, action) => (
        <>
          <div className='d-flex align-item-center'>
            {action.iconImage && <img src={action.iconImage} alt="" height={45} className='d-block me-3' />}
            <div>
              <p className='mb-1 text-sm'>{action.productServiceName}</p>
              {action.type == 1 ? <span className='badge badge-sm bg-info text-white'>Product</span> : <span className='badge bg-warning text-dark'>Service</span>}
            </div>
          </div>
        </>
      )
    },
    {
      title: 'Brand',
      dataIndex: 'brandName',
      key: 'brandName',
      sorter: (a, b) => a.brandName.localeCompare(b.brandName),
      filter: (value, record) => record.brandName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.brandName.toLowerCase().includes(value.toLowerCase()),
    },
    // {
    //   title: 'Category',
    //   dataIndex: 'serviceCategoryName',
    //   key: 'serviceCategoryName',
    //   sorter: (a, b) => a.serviceCategoryName.localeCompare(b.serviceCategoryName),
    //   filter: (value, record) => record.serviceCategoryName.toLowerCase().includes(value.toLowerCase()),
    //   filterIcon: <SearchOutlined />,
    //   onFilter: (value, record) => record.serviceCategoryName.toLowerCase().includes(value.toLowerCase()),
    // },
    {
      title: 'Service Types',
      dataIndex: 'childRecords',
      key: 'serviceTypes',
      sorter: (a, b) => a.serviceTypeName.localeCompare(b.serviceTypeName),
      filter: (value, record) => record.serviceTypeName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.serviceTypeName.toLowerCase().includes(value.toLowerCase()),
      render: (i, action) => (
        <>
          {action.childRecords && action.childRecords.length} items
        </>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (i, action) => (
        <button 
          type='button' 
          className={`btn badge badge-xs ${action.isActive == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
          onClick={() => setSelectedStatus({
              keyID: action.parentId,
              isActive: action.isActive ? 0 : 1
          })}
        >
            {action.isActive ? 'Active': 'Deactivated'}
        </button>
      )
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (i, action) => (
        <>
          <Link to={`/service/product/edit?id=${action.parentId}`} className="btn badge badge-xs badge-warning fw-600 text-xs mb-0" onClick={() => setViewEditItem(action.productServiceName)}>
            View & Edit
          </Link>
          <button 
            type='button'
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={()=>setSelectedRecord(action.parentId)}
          >
            Delete
          </button>
        </>
      ),
    }
  ]


  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white">Service/Products</h5>
        </div>
        <div className="col-auto">
          <Link
            to="/service/product/add-product"
            className="btn btn-icon btn-3 btn-white text-primary mb-0 mx-1"
          >
            <i className="fa fa-plus me-2" /> Add New Product
          </Link>
          {/* <a
            data-bs-toggle="modal"
            data-bs-target="#servicetypeimport"
            className="btn btn-icon btn-3 btn-white text-primary mb-0 mx-1"
          >
            <i className="fa fa-cloud-upload me-2" /> Import Service/Products
          </a> */}
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header p-4">
          <div className="row gx-3">
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Product/ Service Name"
                value={sortFilter?.search || ""}
                onChange={(e) => setSortFilter({...sortFilter, search: e.target.value})}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                onChange={(e) => setSortFilter({ ...sortFilter, outletID: e.target.value })}
                value={sortFilter?.outletID}
                disabled={(outletList.isSuccess === true && !isDropdownPermission(user.role_Id))}
              >
                <option value="">
                  All Category
                </option>
                {
                  outletList?.data?.data.map((elem, i) => (
                    <option value={elem.outletId} key={i}>{elem.outletName}</option>
                  ))
                }
              </select>
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {serviceProductsApi.isError && <Error/>}
          {serviceProductsApi.isLoading && <Loader height="500px"/>}
          {
            serviceProductsApi.isSuccess && (
              <>
                <Table 
                  columns={columns} 
                  dataSource={serviceProductsApi?.data?.data}
                />
              </>
            )
          }
        </div>
      </div>

      {/* STATUS CHANGE MODAL */}
      <Modal
        show={selectedStatus}
        onHide={() => setSelectedStatus(null)}
        size="sm"
        centered
      >
        <Modal.Body className='text-center p-4'>
          <h5>Are you sure you want to change status?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={() => (setSelectedStatus(null))}>Cancel</button>
            <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
          </div>
        </Modal.Body>
      </Modal>

      {/* DELETE MODAL */}
      <Modal
        show={selectedRecord}
        onHide={() => setSelectedRecord(null)}
        size="sm"
        centered
      >
        <Modal.Body className='text-center p-4'>
          <h5>Are you sure you want to delete the brand?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={() => (setSelectedRecord(null))}>Cancel</button>
            <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Products